import React, { useState } from 'react';

const AuthForm = ({ onLogin, onLogout, isAuthenticated, userInfo }) => {
  const [formData, setFormData] = useState({
    userId: '',
    tenant: '',
    token: ''
  });
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.userId.trim() || !formData.tenant.trim() || !formData.token.trim()) {
      setError('Все поля обязательны для заполнения');
      return;
    }

    // Validate userId is numeric
    if (!/^\d+$/.test(formData.userId.trim())) {
      setError('User ID должен содержать только цифры');
      return;
    }

    try {
      onLogin(formData);
      setError('');
    } catch (err) {
      setError('Ошибка при входе в систему');
    }
  };

  const handleLogout = () => {
    onLogout();
  };

  if (isAuthenticated) {
    return (
      <div className="auth-form authenticated">
        <div className="user-info">
          <h3>Вы авторизованы</h3>
          <div className="user-details">
            <p><strong>User ID:</strong> {userInfo.userId}</p>
            <p><strong>Tenant:</strong> {userInfo.tenant}</p>
            <p><strong>Token:</strong> {userInfo.token.substring(0, 10)}...</p>
          </div>
          <button 
            onClick={handleLogout}
            className="logout-btn"
          >
            Выйти
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <h2>Авторизация</h2>
      <p>Введите данные для входа в систему</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="userId">User ID:</label>
          <input
            type="text"
            id="userId"
            name="userId"
            value={formData.userId}
            onChange={handleInputChange}
            placeholder="Введите User ID (только цифры)"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="tenant">Tenant:</label>
          <input
            type="text"
            id="tenant"
            name="tenant"
            value={formData.tenant}
            onChange={handleInputChange}
            placeholder="Введите название tenant"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="token">Token:</label>
          <input
            type="text"
            id="token"
            name="token"
            value={formData.token}
            onChange={handleInputChange}
            placeholder="Введите токен"
            required
          />
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <button type="submit" className="login-btn">
          Войти
        </button>
      </form>
    </div>
  );
};

export default AuthForm;
